module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ca977f745ed62116cbba6d4b0d7dc611.png";